export enum EopReportSectionDetailType {
  NOT_SET = -1,
  EopReportSectionDetail_Amount = 0,
  EopReportSectionDetail_CountAmount = 1,
  EopReportSectionDetail_Description = 2,
  EopReportSectionDetail_Variance = 3,
  EopReportSectionDetail_Tax = 4,
  EopReportSectionDetail_SalesPayments = 5
}
